import Utils from '../../utils/utils'
import mobileDetect from "../../utils/mobileDetect";

const state = {
	isIOSDevice: false,
	isMobileDevice :false
}

const getters = {
	getIsIOSDevice: state => {
		return state.isIOSDevice
	}
}

const actions = {
	async getIsIOSDevice({ commit }) {
		commit('isIOSDevice', await mobileDetect.isIosMobile())
		commit('isMobileDevice', mobileDetect.isMobileDevice())
	}
}

const mutations = {
	isIOSDevice(state, data) {
		if (Utils.isEmptyObject(data)) {
			state.isIOSDevice = false
		}

		state.isIOSDevice = data
	},

	isMobileDevice(state, data) {
		if (Utils.isEmptyObject(data)) {
			state.isMobileDevice = false
		}

		state.isMobileDevice = data
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}